module.exports = __webpack_public_path__ + "static/media/po-undercarriage-3.41720f6e.png";